// @flow

// Libs
import React, { Component } from 'react'
import _isEmpty from 'lodash/isEmpty'
import _get from 'lodash/get'

// Components
import ShapeCell from '../components/ShapeCell'

// Icons
import Map from 'fc-icons/src/Map'

// Constants
import { FARM, FIELD } from 'fc-model-assets'
import { PROP_SHAPE_DATA, PROP_FEATURES } from 'fc-model-shapes'
import { ATTR_ASSET_ID, ATTR_CATEGORY, ATTR_SHAPE, ATTR_MAP_VIEW } from '../constants'

// Columns config
import COLUMNS from 'fc-datatable-assets/src/columnsConfig'

// Types
import type { AssetRecord } from '../../types'

// Styles
import { primary } from 'hfty-styles/src/colors'
const styles = {
  mapIcon: {
    padding: '2px 7px',
    cursor: 'pointer',
  },
}

// Props type
type Props = {
  children?: any,
  mobile: boolean,
  onClickMap: Function,
  seasonSpecificFields: Object,
}

// Exports
export default function assetsTable(AssetDataTable: Function): Function {
  return class AssetsTable extends Component {
    props: Props
    renderer: { [string]: Function }

    constructor(props: Props) {
      super(props)

      this.renderer = {
        [ATTR_SHAPE]: this.renderShape.bind(this),
        [ATTR_MAP_VIEW]: this.renderMapIcon.bind(this),
      }
    }

    renderShape(record: AssetRecord): ?React.Element<any> {
      let recordHasShape = record[ATTR_SHAPE]

      if (recordHasShape && record[ATTR_CATEGORY] === FIELD) {
        const features: Array = _get(record, `[${ATTR_SHAPE}].${PROP_SHAPE_DATA}.${PROP_FEATURES}`, [])

        recordHasShape = features.length > 0
      }

      return recordHasShape ? <ShapeCell shape={record[ATTR_SHAPE]} /> : null
    }

    renderMapIcon(record: AssetRecord): ?React.Element<any> {
      const isFarm = record[ATTR_CATEGORY] === FARM
      const assetId = record[ATTR_ASSET_ID]
      const isFarmHasFields = isFarm && this.props.seasonSpecificFields[assetId].length > 0
      const hasShape = !_isEmpty(record[ATTR_SHAPE])
      let color = primary()
      let disabled = true

      if (isFarmHasFields || hasShape) {
        color = primary(0.8)
        disabled = false
      }

      return (
        <div
          style={styles.mapIcon}
          onClick={() => {
            if (disabled) {
              return
            }

            this.props.onClickMap(record)
          }}
        >
          <Map color={color} />
        </div>
      )
    }

    render(): React.Element<any> {
      return (
        <AssetDataTable
          columns={COLUMNS}
          renderer={this.renderer}
          defaultColumn={ATTR_ASSET_ID}
          tools={this.props.children}
          mobile={this.props.mobile}
        />
      )
    }
  }
}
